import { ThemeMapping } from './ThemeMapping'
export default ThemeMapping
